import React from 'react'
import { Select, Spin } from 'antd'
import { listAllEmployee } from './action'
import debounce from 'lodash/debounce'
import _ from 'lodash'
import InputBox from '../../components/_utils/InputBox'

const { Option } = Select

class EmployeeTypeheadComponent extends React.Component {
  state = {
    arrList: [],
    value: [],
    fetching: false,
    name: '',
    employeeId: ''
  }


  constructor(props) {
    super(props)
  }

  _getEmployeeId = () => {
    let { employeeId } = this.props
    if (employeeId) {
      this.setState({
        employeeId
      }, () => {
        this.fetchEmployee()
      })
    }
  }

  componentDidMount() {
    this._getEmployeeId()
  }

  fetchEmployee = async (name) => {
    let { employeeId } = this.state
    this.setState({ arrList: [], fetching: true })
    let obj = {
      results: 30,
      count: 30,
      select: ['name'],
      name,
      regExFilters: ['name']
    }
    if (employeeId && !name) {
      obj._id = employeeId
    }
    let { data } = await listAllEmployee(obj)
    let dataNew = []
    if (data && data.data && data.data.length) {
      _.each(data.data, (user) => {
        dataNew.push({
          text: user.name,
          value: user._id
        })
      })
    }
    let newObj = {
      arrList: dataNew
    }
    if (employeeId && !name && dataNew && dataNew.length) {
      let currentAgent = dataNew[0]
      newObj.name = {
        key: currentAgent.value,
        label: currentAgent.text
      }
    }
    this.setState(newObj)

  }

  handleChange = value => {
    let { onSelect } = this.props
    this.setState({
      name: value,
      employeeId: value && value.key ? value.key : '',
      data: [],
      fetching: false
    })
    onSelect((value && value.key) || '')
  }

  render() {
    const { fetching, arrList, name, required = false } = this.state
    return (
      <InputBox title={'Select Employee'}>
        <Select
          labelInValue
          value={name || undefined}
          className={'mt10'}
          placeholder='Select Employee'
          allowClear={true}
          notFoundContent={fetching ? <Spin size='small' /> : null}
          filterOption={false}
          showSearch={true}
          onSearch={debounce(this.fetchEmployee, 500)}
          onChange={this.handleChange}>
          {arrList.map(d => (
            <Option key={d.value} value={d.value}>{d.text}</Option>
          ))}
        </Select>
      </InputBox>

    )
  }
}

export default EmployeeTypeheadComponent
